import React from 'react'
import { useCurrencySymbol } from '../../../../../utils/currencyUtils';
import CommaConvert from '../../../../../utils/CommaConvert';

const ConsolidatedHardware = ({ hardwareEntries }) => {
    const currency = useCurrencySymbol();
    const USAComma = CommaConvert();
    return (
        <div>
            {/* {showActionToAssign?.[index] ===
                "tasktable" && ( */}
            <div
                className={`flex justify-end`}
            >
                <div className="w-[50%]">
                    <div className="head flex text-center bg-[#e8e8e8]  text-xs">
                        <div className="w-[30%] border-l p-1">
                            Parts
                        </div>
                        <div className="w-[20%]  p-1">
                            Quantity
                        </div>
                        <div className="w-[20%]  p-1">
                            Unit Cost ({currency})
                        </div>
                        <div className="w-[30%] border-r p-1">
                            Total Cost ({currency})
                        </div>
                    </div>
                    <div className="head flex text-center text-xs border-b">
                        <div className="w-[30%] border-l p-1">

                        </div>
                        <div className="w-[20%]  p-1">
                        </div>
                        <div className="w-[20%]  p-1">
                        </div>
                        <div className="w-[30%] border-r p-1">
                            {USAComma(
                                hardwareEntries?.reduce(
                                    (sum, item) =>
                                        sum + (Number(item.totalprice) || 0),
                                    0
                                ) || 0
                            )}
                        </div>
                    </div>
                    {hardwareEntries?.map(
                        (entry, index) => (
                            <div
                                key={index}
                                className="head flex text-center"
                            >
                                <div className="w-[30%] border-b border-l p-1">
                                    {entry.assemblepartdescription ||
                                        ""}
                                </div>
                                <div className="w-[20%] border-b p-1">
                                    {entry.quantity || " "}
                                </div>
                                <div className="w-[20%] border-b p-1">
                                    {USAComma(
                                        entry.unitprice || " "
                                    )}
                                </div>
                                <div className="w-[30%] border-b border-r p-1">
                                    {USAComma(
                                        entry.totalprice || " "
                                    )}
                                </div>
                            </div>
                        )
                    )}
                </div>
            </div>
            {/* )} */}
        </div>
    )
}

export default ConsolidatedHardware
